import React, { useState } from 'react';
import { Modal, Button, Alert } from 'angieslist-react-components';
import { reduxForm, Field, Form } from 'redux-form';
import { InputField } from 'angieslist-app-platform/lib/browser/forms';
import { Track, tracker } from 'angieslist-app-platform';
import '../ShowcaseMedia.scss';
import ImageEditor from './ImageEditor';

type Props = {
  serviceProviderId: String | Number,
  mediaId: Number,
  imagePath: String,
  updateShowcaseMediaError: Object,
  updateShowcaseMedia: (values: Object) => void,
  handleSubmit: (updateShowcaseMedia: Function) => void,
  updateShowcaseMediaReset: () => void,
  updateShowcaseMediaIsLoading: Boolean,
  rotationEnabled: Boolean,
};

const EditSingleImageModal = ({
  serviceProviderId,
  imagePath,
  mediaId,
  handleSubmit,
  updateShowcaseMedia,
  updateShowcaseMediaError,
  updateShowcaseMediaReset,
  updateShowcaseMediaIsLoading,
  rotationEnabled,
}: Props) => {
  const [show, setShow] = useState(false);
  const [rotate, setRotate] = useState(0);
  const [imageCanvasLoading, setImageCanvasLoading] = useState(true);

  const handleShow = () => setShow(true);


  const handleClose = () => {
    tracker.track('Item Clicked', {
      activityLocation: 'Edit Image Modal',
      description: 'Cancel',
      serviceProviderId,
    });
    setShow(false);
    setRotate(0);
    // Resetting here is vital so when a user cancels Redux doesn't hold the state, also
    // when user submits it only submits the changed field
    updateShowcaseMediaReset();
  };

  const mediaIdString = mediaId.toString();


  const handleImageUpdate = (values: any) => {
    const canvas = this.editor.getImage();
    let imageType = imagePath.split('.').pop();
    if (imageType === 'jpg') { imageType = 'jpeg'; }
    return new Promise((resolve, reject) => {
      canvas.toBlob(
        (blob) => {
          updateShowcaseMedia(true, values, blob)
            .then(resolve)
            .catch(reject);
        },
        `image/${imageType}`,
      );
    });
  };

  // eslint-disable-next-line no-return-assign
  const setEditorRef = editor => this.editor = editor;

  return (
    <span>
      <i
        id={`edit-icon-${mediaIdString}`}
        className="icon icon-pencil pencil"
        role="button"
        onClick={handleShow}
        onKeyPress={handleShow}
        tabIndex={mediaId}
      >
        <span className="edit-text">Edit</span>
      </i>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        className="Edit-Image-Modal--Container"
      >
        <Form
          onSubmit={
            handleSubmit(values => handleImageUpdate({ ...values, mediaId }))
          }
          name="EditImageModalForm"
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Image</Modal.Title>
          </Modal.Header>
          <If condition={mediaId && imagePath}>
            <Modal.Body>
              <ImageEditor
                mediaId={mediaId}
                url={imagePath}
                rotate={rotate}
                setRotate={setRotate}
                setImageEditorRef={setEditorRef}
                imageCanvasLoading={imageCanvasLoading}
                setImageCanvasLoading={setImageCanvasLoading}
                rotationEnabled={rotationEnabled}
              />

              <Field
                name={`imageDescriptionField_${mediaIdString}`}
                label="Image Description"
                id={`Edit-Image-Modal--Image-Description-${mediaIdString}`}
                component={InputField}
                type="textarea"
                style={{ height: '5em' }}
                placeholder="Please enter a description here"
              />
            </Modal.Body>
            <Modal.Footer>
              <If condition={updateShowcaseMediaError}>
                <Alert bsStyle="danger" className="text-center">
                  There was an error editing your image, please try again.
                </Alert>
              </If>
              <Track>
                <Button
                  id="Edit-Image-Modal--Cancel"
                  bsSize="small"
                  bsStyle="default-office"
                  onClick={handleClose}
                >
                Cancel
                </Button>
              </Track>
              <Track>
                <Button
                  loading={updateShowcaseMediaIsLoading || imageCanvasLoading}
                  disabled={updateShowcaseMediaIsLoading || imageCanvasLoading}
                  id="Edit-Image-Modal--Save"
                  bsStyle="primary-office"
                  bsSize="small"
                  type="submit"
                  flat
                >
                Save
                </Button>
              </Track>
            </Modal.Footer>
          </If>
        </Form>
      </Modal>
    </span>
  );
};

export default (
  reduxForm({
    form: 'EditImageModalForm',
  })
)(EditSingleImageModal);



// WEBPACK FOOTER //
// ./src/modules/showcase/browser/components/EditSingleImageModalForm.js